const ADMIN_EMAILS = ['robin.barker1982@gmail.com'];

export function isAdminUser(user) {
  const email = (user?.email || '').trim().toLowerCase();
  return Boolean(email && ADMIN_EMAILS.includes(email));
}
